import * as React from "react"
import { cn } from "@/lib/utils"

const environments = {
  production: {
    label: "PRODUCTION",
    className: "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-500 border-green-200 dark:border-green-900/50",
  },
  staging: {
    label: "STAGING",
    className: "bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-500 border-blue-200 dark:border-blue-900/50",
  },
  test: {
    label: "TEST ENV",
    className: "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-500 border-yellow-200 dark:border-yellow-900/50",
  },
  development: {
    label: "DEV",
    className: "bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-500 border-purple-200 dark:border-purple-900/50",
  },
  demo: {
    label: "DEMO",
    className: "bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-500 border-orange-200 dark:border-orange-900/50",
  },
}

const EnvironmentBadge = React.forwardRef(({
  className,
  environment = "test",
  ...props
}, ref) => {
  const config = environments[environment] || environments.test

  return (
    <div
      ref={ref}
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold tracking-wide border",
        config.className,
        className
      )}
      role="status"
      aria-label={`Environment: ${config.label}`}
      {...props}
    >
      {config.label}
    </div>
  )
})

EnvironmentBadge.displayName = "EnvironmentBadge"

export { EnvironmentBadge, environments }
